// import type { Plugin } from 'vue'

import { forEach } from "lodash-es"
import CryptoJS from 'crypto-js'
import * as imageConversion from 'image-conversion'
/**
 *
 * @param component 需要注册的组件
 * @param alias 组件别名
 * @returns any
 */
export const withInstall = <T>(component: T, alias?: string) => {
  const comp = component as any
  comp.install = (app: any) => {
    app.component(comp.name || comp.displayName, component)
    if (alias) {
      app.config.globalProperties[alias] = component
    }
  }
  return component as T & Plugin
}

/**
 * @param str 需要转下划线的驼峰字符串
 * @returns 字符串下划线
 */
export const humpToUnderline = (str: string): string => {
  return str.replace(/([A-Z])/g, '-$1').toLowerCase()
}

/**
 * @param str 需要转驼峰的下划线字符串
 * @returns 字符串驼峰
 */
export const underlineToHump = (str: string): string => {
  if (!str) return ''
  return str.replace(/\-(\w)/g, (_, letter: string) => {
    return letter.toUpperCase()
  })
}

export const setCssVar = (prop: string, val: any, dom = document.documentElement) => {
  dom.style.setProperty(prop, val)
}

/**
 * 查找数组对象的某个下标
 * @param {Array} ary 查找的数组
 * @param {Functon} fn 判断的方法
 */
// eslint-disable-next-line
export const findIndex = <T = Recordable>(ary: Array<T>, fn: Fn): number => {
  if (ary.findIndex) {
    return ary.findIndex(fn)
  }
  let index = -1
  ary.some((item: T, i: number, ary: Array<T>) => {
    const ret: T = fn(item, i, ary)
    if (ret) {
      index = i
      return ret
    }
  })
  return index
}

export const trim = (str: string) => {
  return str.replace(/(^\s*)|(\s*$)/g, '')
}

/**
 * @param {Date | number | string} time 需要转换的时间
 * @param {String} fmt 需要转换的格式 如 yyyy-MM-dd、yyyy-MM-dd HH:mm:ss
 */
export function formatTime(time: Date | number | string, fmt='yyyy-MM-dd HH:mm:ss' as any) {
  if (!time) return ''
  else {
    if(!isNaN(time)){
      time = Number(time)
      const MIN_TIMESTAMP = 0; // 最小可能的秒时间戳
      const MAX_TIMESTAMP = Math.floor(Date.now() / 1000)
      if(time >= MIN_TIMESTAMP && time <= MAX_TIMESTAMP){
        time = time * 1000
      }      
    }
    const date = new Date(time)
    const o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'H+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
      'q+': Math.floor((date.getMonth() + 3) / 3),
      S: date.getMilliseconds()
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (const k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
        )
      }
    }
    return fmt
  }
}

/**
 * 生成随机字符串
 */
export function toAnyString() {
  const str: string = 'xxxxx-xxxxx-4xxxx-yxxxx-xxxxx'.replace(/[xy]/g, (c: string) => {
    const r: number = (Math.random() * 16) | 0
    const v: number = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString()
  })
  return str
}


// /**
//  * Date格式转换
//  */
//  export function formatDate (inputDate:any, fmt='YYYY-mm-dd HH:MM:SS') {
//   if (!inputDate) {
//     return ""
//   }
//   let ret:any
//   const date = new Date(inputDate)
//   const opt = {
//       "Y+": date.getFullYear().toString(),        // 年
//       "m+": (date.getMonth() + 1).toString(),     // 月
//       "d+": date.getDate().toString(),            // 日
//       "H+": date.getHours().toString(),           // 时
//       "M+": date.getMinutes().toString(),         // 分
//       "S+": date.getSeconds().toString()          // 秒
//       // 有其他格式化字符需求可以继续添加，必须转化成字符串
//   }
//   for (const k in opt) {
//     ret = new RegExp("(" + k + ")").exec(fmt)
//     if (ret) {
//         fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
//     }
//   }
//   return fmt
// }


/**
 * file转base64
 */
export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    let res:any = "";
    reader.readAsDataURL(file)
    reader.onload = function() {
      res = reader.result
    };
    reader.onerror = function(err) {
      reject("")
    }
    reader.onloadend = function() {
      resolve(res)
    }
  })
}


/**
 * list结构数据转换成tree结构
 */
export function listToTree(input:any[], idKeyName='id', parentKeyName='parent_id', childKeyName='children'):any[] {
  function findChild(node:any, list:any[], idKeyName:string, parentKeyName:string, childKeyName:string):any {
    for (const item of list) {
      if (node[idKeyName].toString() === item[parentKeyName].toString()) {
        if (!node[childKeyName]) {
          node[childKeyName] = <any>[]
        }
        node[childKeyName].push(findChild(item, list, idKeyName, parentKeyName, childKeyName))
      }
    }
    return node
  }
	// 先找出跟节点，然后递归的找跟节点的所有child
	const res:any[] = []
  for (const item of input) {
    if (item[parentKeyName].toString() === '0') {
      res.push(findChild(item, input, idKeyName, parentKeyName, childKeyName))
    }
  }
	return res
}

/**
 * 寻找dom元素的子节点
 */
export function serachDomChild(childClassName:string, srcDom:any, dstArr:any) {
  const classList = srcDom.classList
  if (classList.contains(childClassName)) dstArr.push(srcDom)
  const children = srcDom.children
  if (!children || children.length === 0) return
  for (const child of children) {
    serachDomChild(childClassName, child, dstArr)
  }
}

export function copyTextToClipboard(content) {
  const input = document.createElement("input") // 创建input对象
  input.value = content // 设置复制内容
  document.body.appendChild(input) // 添加临时实例
  input.select() // 选择实例内容
  document.execCommand("Copy") // 执行复制
  document.body.removeChild(input) // 删除临时实例
}

/**
 * 计算字符串的字符数
 * 数字 48-57
 * 大写英文 65-90
 * 小写英文 97-122
 */
export function strCodeLen(str) {
  let count = 0
  const charArr = str.split('')
  charArr.forEach(item => {
    const charCode = item.charCodeAt()
    // 数字
    if (charCode >= 0 && charCode <= 128) count += 1
    else count += 2
  })
  return count
}

// 动态替换favicon
export function changeFavicon(iconUrl) {
  // console.log('changeFavicon:', iconUrl)
  let $favicon:any = document.querySelector('link[rel="icon"]')
  if ($favicon !== null) {
    $favicon.href = iconUrl
  } else {
    $favicon = document.createElement("link");
    $favicon.rel = "icon"
    $favicon.href = iconUrl
    document.head.appendChild($favicon)
  }
}

//aes 加密
export function AESEncrypt (pwd, user) {
  if(user){
    user = user.toLowerCase()
  }
  const AESKey = CryptoJS.MD5(user).toString();
  const key = CryptoJS.enc.Utf8.parse(AESKey);
  const iv = CryptoJS.enc.Utf8.parse(AESKey.substring(0, 16)); // 偏移量：规定的是key前15位
  const srcs = CryptoJS.enc.Utf8.parse(pwd);
  const encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}

/**
 * 替换字符串中的占位符 exp:{0} {1}
 * arguments[0]: 需要被替换的字符串
 */
export function StrFormat(str, ...args){
  return str.replace(/\$(\d+)\$/g, (match, number) => {
    return args[number] || '';
  });  
}


export function TreeDepth(root) {
  if (!root) return 0;
  let maxDepth = 0;
  if(root.children && root.children.length>0){
    for (const node of root.children) {
      const depth = TreeDepth(node);
      maxDepth = Math.max(maxDepth, depth);
    }    
  }
  return maxDepth + 1;
}

export function UUID() {
  const s = [];
  const hexDigits = "0123456789abcdef";
  for (let i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  const uuid = s.join("");
  return uuid;
}
export function Str2Time(str){
  let hour=0,min=0
  if(str){
      const arr = str.split(':')
      if(arr.length==2){
          hour = Number(arr[0])
          min = Number(arr[1])
      }
  }
  return [hour,min]
}

export function Utc2Localtime(timeStr){
  const dt = new Date()
  const offset = dt.getTimezoneOffset()
  if(offset==0) return timeStr
  const [hour,min] = Str2Time(timeStr)
  dt.setHours(hour,min,0,0)
  dt.setMinutes(dt.getMinutes()-offset)
  const hourStr = dt.getHours()<10? `0${dt.getHours()}`:`${dt.getHours()}`
  const minStr = dt.getMinutes()<10? `0${dt.getMinutes()}`:`${dt.getMinutes()}`
  return `${hourStr}:${minStr}`
}

export function ConvertShiftTime(data,dt:Date){
  data = JSON.parse(JSON.stringify(data))
  const shiftInfo = {
    today:{
      from:null,
      to:null,
      day:{
        from:null,
        to:null
      },
      night:{
        from:null,
        to:null
      }
    },
    yesterday:{
      from:null,
      to:null,
      day:{
        from:null,
        to:null
      },
      night:{
        from:null,
        to:null
      }
    }
  }  
  // for(const key in data){
  //   data[key].start = Utc2Localtime(data[key].start)
  //   data[key].end = Utc2Localtime(data[key].end)
  // }                
  const dStart = new Date(dt),dEnd=new Date(dt), nStart = new Date(dt),nEnd=new Date(dt)
  const dStartArr = data.day.start.split(':')
  const dEndArr = data.day.end.split(':')
  const nStartArr = data.night.start.split(':')
  const nEndArr = data.night.end.split(':')
  dStart.setHours(dStartArr[0],dStartArr[1],0,0)
  dEnd.setHours(dEndArr[0],dEndArr[1],0,0)
  nStart.setHours(nStartArr[0],nStartArr[1],0,0)
  nEnd.setHours(nEndArr[0],nEndArr[1],0,0)

  if(nStart.getTime()<dStart.getTime()){
      nStart.setDate(nStart.getDate()+1)
  }
  if(nEnd.getTime()<nStart.getTime()){
      nEnd.setDate(nEnd.getDate()+1)
  } 
  if(dEnd.getTime()<dStart.getTime()){
      dEnd.setDate(dEnd.getDate()+1)
  }
  shiftInfo.today.from = dStart
  shiftInfo.today.to = nEnd
  shiftInfo.today.day = {
      from:dStart,
      to:dEnd
  }
  shiftInfo.today.night = {
      from:nStart,
      to:nEnd
  }      

  const ydStart = new Date(dStart),ydEnd=new Date(dEnd), ynStart = new Date(nStart),ynEnd=new Date(nEnd)
  ydStart.setDate(dStart.getDate()-1)
  ydEnd.setDate(ydEnd.getDate()-1)
  ynStart.setDate(ynStart.getDate()-1)
  ynEnd.setDate(ynEnd.getDate()-1)
  shiftInfo.yesterday.from = ydStart
  shiftInfo.yesterday.to = ynEnd 
  shiftInfo.yesterday.day = {
      from:ydStart ,
      to:ydEnd
  }
  shiftInfo.yesterday.night = {
      from:ynStart,
      to:ynEnd
  }
  return shiftInfo  
}

export function Localtime2utc(timeStr){
  const dt = new Date()
  const offset = dt.getTimezoneOffset()
  if(offset==0) return timeStr
  const [hour,min] = Str2Time(timeStr)
  dt.setHours(hour,min,0,0)
  dt.setMinutes(dt.getMinutes()+offset)
  const hourStr = dt.getHours()<10? `0${dt.getHours()}`:`${dt.getHours()}`
  const minStr = dt.getMinutes()<10? `0${dt.getMinutes()}`:`${dt.getMinutes()}`
  return `${hourStr}:${minStr}`
}

export function MsToTime(val,type=null as any){
  let time = val, unit = 's'
  if(type){
    unit = type
  }  
  if(!val || isNaN(val)){
    time = 0
    return { time, unit}
  }
  // Min Hour Day Week
  time = time/1000 //s
  if(type){
    switch (type) {
      case 'Min':
        time = time/60
        break;
      case 'Hour':
        time = time/(60*60)
        break;
      case 'Day':
        time = time/(60*60*24)
        break;
      case 'Week':
        time = time/(60*60*24*7)
        break;                             
      default:
        unit = 's'
        break;
    }
  }else{
    if(time>60){
      time = time/60 //min
      unit = 'Min'
      if(time>60){
        time = time/60 //hour
        unit = 'Hour'
        if(time>24){
          time = time/24 //day
          unit = 'Day'
          if(time>7){
            time = time/7 //day
            unit = 'Week'
          } 
        }     
      }
    }
  }
  if(time%1 >0){
    time = Number(time.toFixed(2))
  }
  return { time, unit}
}

export function Debounce(fn, wait, immediate=false) {
  let timer;
  return function () {
      if (timer) clearTimeout(timer);
      if (immediate) {
          const callNow = !timer;
          timer = setTimeout(() => {
              timer = null;
          }, wait)
          if (callNow) {
            fn()
              // fn.apply(this, arguments)
          }
      } else {
          timer = setTimeout(() => {
              // fn.apply(this, arguments)
              fn()
          }, wait);
      }
  }
}

// 压缩图片到指定的大小
export function zipImag (file, targetSize) {
  return new Promise((resolve, reject) => {
    const isZip = file.size / 1024 >= targetSize // 判定图片大小是否大于200KB
    if (isZip) {
      // 20kb
      imageConversion.compressAccurately(file, targetSize).then(res => {
        resolve(res)
      })
    } else {
        resolve(file)
    }
  })
}

// 复制到剪切板（兼容旧浏览器方案）
export function copyToClipboard(text) {
  // 创建临时文本域
  const textarea:any = document.createElement("textarea");
  textarea.value = text;
  
  // 隐藏元素并添加到DOM
  textarea.style.position = "fixed";
  textarea.style.opacity = 0;
  document.body.appendChild(textarea);
  
  // 选中并复制
  textarea.select();
  try {
    document.execCommand("copy");
    return null
  } catch (err:any) {
    return err.toString()
  } finally {
    // 清理DOM
    document.body.removeChild(textarea);
  }
}

export function TimeDuration(duration){
  if (!duration) return '0min'
  const lenMillSec = duration
  const hour = Math.floor(lenMillSec/3600000)
  const min = Math.floor((lenMillSec-hour*3600000)/60000)
  const sec = Math.round((lenMillSec-hour*3600000-min*60000)/1000)
  const hourStr = hour===0?'':hour+'H'
  const minStr = min===0?'':min+'min'
  const secStr = sec+'sec'
  let res = ''
  if (hour===0&&min===0) res = secStr
  else res = hourStr+minStr
  return res
}

/**
 * 防抖函数
 * @param func 需要防抖的函数
 * @param delay 延迟时间（毫秒），默认 100ms
 * @returns 经过防抖处理的函数
 */
export function debounce<T extends (...args: any[]) => void>(
  func: T,
  delay = 100
): (...args: Parameters<T>) => void {
  let timer: NodeJS.Timeout | null = null;

  return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
    // 清除上一次的定时器
    if (timer) {
      clearTimeout(timer);
    }

    // 重新设置定时器
    timer = setTimeout(() => {
      func.apply(this, args);
      timer = null;
    }, delay);
  };
}

/**
 * 生成 [min, max] 之间的随机整数（包含边界）
 * @param min 最小整数（包含）
 * @param max 最大整数（包含）
 * @returns 随机整数
 */
export function getRandomInt(min: number, max: number): number {
  // 先转换为整数（避免传入小数）
  const intMin = Math.ceil(min);
  const intMax = Math.floor(max);
  if (intMin > intMax) {
    throw new Error("min 必须小于等于 max");
  }
  // 核心公式：[0, max-min+1) 取整后 + min
  return Math.floor(Math.random() * (intMax - intMin + 1)) + intMin;
}

/**
 * 将树形结构转换为列表
 * @param {Array} tree 树形结构数组
 * @param {string} childrenKey 子节点属性名，默认为'children'
 * @param {string} traverseType 遍历方式，'dfs'（深度优先）或'bfs'（广度优先），默认为'dfs'
 * @returns {Array} 转换后的列表
 */
export function treeToList(tree, childrenKey = 'children', traverseType = 'bfs') {
    if (!Array.isArray(tree)) {
        throw new Error('输入必须是数组类型的树形结构');
    }

    const list:any = [];
    const stackOrQueue = [...tree]; // 根据遍历方式分别作为栈(DFS)或队列(BFS)

    while (stackOrQueue.length > 0) {
        // 深度优先用栈(后进先出)，广度优先用队列(先进先出)
        const node = traverseType === 'dfs' 
            ? stackOrQueue.pop() 
            : stackOrQueue.shift();

        // 保存当前节点（创建副本避免修改原对象）
        const nodeCopy = { ...node };
        // 移除children属性（可选，根据需求决定是否保留）
        delete nodeCopy[childrenKey];
        list.push(nodeCopy);

        // 处理子节点
        if (node[childrenKey] && Array.isArray(node[childrenKey]) && node[childrenKey].length > 0) {
            // DFS时子节点逆序入栈，保证遍历顺序正确；BFS直接顺序入队
            const children = traverseType === 'dfs' 
                ? [...node[childrenKey]].reverse() 
                : node[childrenKey];
            stackOrQueue.push(...children);
        }
    }

    return list;
}

/**
 * 将树形结构数组转换为平铺数组（深度优先：先遍历父节点+所有子节点，再遍历下一个同级节点）
 * @param {Array} tree - 树形结构数组，每个节点包含 children（子节点数组）属性
 * @returns {Array} 平铺后的一维数组
 */
export function treeToListOfDfs(tree) {
  // 存储最终结果
  const result:any = [];

  // 递归处理单个节点（深度优先）
  function dfs(node) {
    // 复制节点并排除 children 属性（避免子节点数组混入结果）
    const { children, ...rest } = node;
    result.push(rest);

    // 若有子节点，递归处理子节点数组
    if (Array.isArray(children) && children.length > 0) {
      children.forEach(child => dfs(child));
    }
  }

  // 遍历顶层数组的每个节点，依次深度优先处理
  tree.forEach(node => dfs(node));

  return result;
}